import React, { useState, useEffect } from 'react';
import { Menu, X, Phone, Instagram } from 'lucide-react';
import { Button } from './ui/button';
import { companyInfo } from '../utils/mockData';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const whatsappNumber = "5585985195369";
  const whatsappMessage = "Olá! Gostaria de solicitar um orçamento.";
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;
  const instagramLink = "https://www.instagram.com/infortech_graficaeassistencia";

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-md' : 'bg-white/95 backdrop-blur-sm'}`
      }>

      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center">
            <button 
              onClick={() => scrollToSection('inicio')}
              className="hover:opacity-80 transition-opacity"
            >
              {/* Desktop Logo - Full Logo with Text */}
              <img 
                src={companyInfo.logo.full}
                alt="Infortech - Gráfica Rápida e Assistência Técnica"
                className="hidden md:block h-12 w-auto object-contain"
              />
              {/* Mobile Logo - Icon Only */}
              <img 
                src={companyInfo.logo.icon}
                alt="Infortech"
                className="md:hidden h-10 w-auto object-contain"
              />
            </button>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('inicio')}
              className="text-gray-700 hover:text-[#1e3a8a] transition-colors font-medium">

              Início
            </button>
            <button
              onClick={() => scrollToSection('servicos')}
              className="text-gray-700 hover:text-[#1e3a8a] transition-colors font-medium">

              Serviços
            </button>
            <button
              onClick={() => scrollToSection('sobre')}
              className="text-gray-700 hover:text-[#1e3a8a] transition-colors font-medium">

              Sobre
            </button>
            <button
              onClick={() => scrollToSection('avaliacoes')}
              className="text-gray-700 hover:text-[#1e3a8a] transition-colors font-medium">

              Avaliações
            </button>
            <button
              onClick={() => scrollToSection('contato')}
              className="text-gray-700 hover:text-[#1e3a8a] transition-colors font-medium">

              Contato
            </button>
          </nav>

          {/* CTA Button */}
          <div className="hidden md:flex items-center gap-3">
            <a
              href={instagramLink}
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-700 hover:text-[#E1306C] transition-colors p-2"
              aria-label="Instagram"
            >
              <Instagram className="w-6 h-6" />
            </a>
            <Button
              onClick={() => window.open(whatsappLink, '_blank')}
              className="bg-[#25D366] hover:bg-[#20BD5C] text-white font-semibold px-6 shadow-lg hover:shadow-xl transition-all">

              <Phone className="w-4 h-4 mr-2" />
              Fale no WhatsApp
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2 text-gray-700 hover:text-[#1e3a8a] transition-colors">

            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen &&
        <div className="md:hidden py-4 border-t">
            <nav className="flex flex-col space-y-4">
              <button
              onClick={() => scrollToSection('inicio')}
              className="text-left text-gray-700 hover:text-[#1e3a8a] transition-colors font-medium">

                Início
              </button>
              <button
              onClick={() => scrollToSection('servicos')}
              className="text-left text-gray-700 hover:text-[#1e3a8a] transition-colors font-medium">

                Serviços
              </button>
              <button
              onClick={() => scrollToSection('sobre')}
              className="text-left text-gray-700 hover:text-[#1e3a8a] transition-colors font-medium">

                Sobre
              </button>
              <button
              onClick={() => scrollToSection('avaliacoes')}
              className="text-left text-gray-700 hover:text-[#1e3a8a] transition-colors font-medium">

                Avaliações
              </button>
              <button
              onClick={() => scrollToSection('contato')}
              className="text-left text-gray-700 hover:text-[#1e3a8a] transition-colors font-medium">

                Contato
              </button>
              <Button
              onClick={() => window.open(whatsappLink, '_blank')}
              className="bg-[#25D366] hover:bg-[#20BD5C] text-white font-semibold w-full">

                <Phone className="w-4 h-4 mr-2" />
                Fale no WhatsApp
              </Button>
              <a
                href={instagramLink}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 text-gray-700 hover:text-[#E1306C] transition-colors font-medium py-2"
              >
                <Instagram className="w-5 h-5" />
                Siga no Instagram
              </a>
            </nav>
          </div>
        }
      </div>
    </header>);

};

export default Header;